import { DoneAll, OpenInNew } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  IconButton,
  List,
  Popover,
  Stack,
  Typography,
  Button,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAllNotifications, markAllRead } from '../../modules/notification';
import NotificationItem from './NotificationItem';

const NotificationsPopover = ({
  open,
  setOpen,
  notifications,
  totalUnRead,
  loading,
  fetchNotifications,
}) => {
  const navigate = useNavigate();

  const handleClose = () => setOpen(null);

  const handleMarkAllRead = async () => {
    try {
      await markAllRead();
      fetchNotifications();
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleClearAll = async () => {
    try {
      clearAllNotifications();
      fetchNotifications();
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleViewAll = () => {
    handleClose();
    navigate('/notifications');
  };

  return (
    <Popover
      open={!!open}
      anchorEl={open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          width: 420,
        },
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 1.5,
          px: 2.5,
        }}>
        <Typography variant="h6">Notifications</Typography>

        <Stack direction="row" spacing={1}>
          {totalUnRead > 0 && <IconButton title="Mark all as read" onClick={handleMarkAllRead}>
            <DoneAll />
          </IconButton>}
          {notifications?.length > 0 && (
            <>
              <IconButton
                title="View all notifications"
                onClick={handleViewAll}>
                <OpenInNew />
              </IconButton>
              <Button
                variant="text"
                color="inherit"
                title="Remove all notifications"
                onClick={handleClearAll}
                disableRipple>
                Clear All
              </Button>
            </>
          )}
        </Stack>
      </Box>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}>
          <CircularProgress size={24} />
        </Box>
      ) : notifications.length === 0 ? (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textAlign: 'center', py: 2 }}>
          You have no new notifications.
        </Typography>
      ) : (
        <>
          <List>
            {notifications.slice(0, 5).map((notification) => (
              <NotificationItem
                key={notification.id}
                notification={notification}
                fetchNotifications={fetchNotifications}
              />
            ))}
          </List>
          {notifications.length > 5 && (
            <Box sx={{ textAlign: 'center', py: 1 }}>
              <Button onClick={handleViewAll}>View All Notifications</Button>
            </Box>
          )}
        </>
      )}
    </Popover>
  );
};

export default NotificationsPopover;
